import { render } from "./ErrorModal.vue?vue&type=template&id=983fc666"
import script from "./ErrorModal.vue?vue&type=script&lang=js"
export * from "./ErrorModal.vue?vue&type=script&lang=js"
script.render = render

export default script